import { ViewsProps } from 'types/reduxTypes/modals';

export const getInitialState = (): ViewsProps => ({
  modals: [],
  toastNotificationPopUp: {
    open: false,
    props: {}
  }
});
